module.exports = __webpack_public_path__ + "static/media/user-info-settings.625dd367.svg";